// SettingsContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import i18n from "../i18n";

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const [timezone, setTimezone] = useState("Europe/Stockholm"); // default
  const [is24Hour, setIs24Hour] = useState(true); // default till 24h
  const [dateFormat, setDateFormat] = useState("YYYY-MM-DD");
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );
  useEffect(() => {
    i18n.changeLanguage(language);
    localStorage.setItem("language", language);
  }, [language]);

  return (
    <SettingsContext.Provider
      value={{
        timezone,
        setTimezone,
        is24Hour,
        setIs24Hour,
        language,
        setLanguage,
        dateFormat,
        setDateFormat,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
